<mat-icon style="text-align: right;width: 100%;margin-bottom: 13px;margin-top: -10px;" mat-button (click)="close()"> 
    X 
</mat-icon>
<div id="print-section">
    <div class="col-md-12">
        <h4 class="title" style="margin-top: 15px;">Statcard</h4>
        <div class="card-box">

            <table class="table" >
                <tbody>
                    <tr>
                        <td>
                            <h5 class="form-lable">Contact #:</h5>
                            <input type="text" pInputText placeholder="" value="A8795641230">
                        </td>
                        <td>
                            <h5 class="form-lable">Customer Name:</h5>
                            <input type="text" pInputText placeholder="" value="Vignesh V">
                        </td>
                        <td>
                            <h5 class="form-lable">Mobile:</h5>
                            <input type="text" pInputText placeholder="" value="9876543210">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h4 class="title-f" style="margin-top: 15px;">Customer Details</h4>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Registered Address:</h5>
                            <input type="text" pInputText placeholder="" value="Registered Address of CH">
                        </td>
                        <td>
                            <h5 class="form-lable">Mailing Address:</h5>
                            <input type="text" pInputText placeholder="" value="Mailing Address of CH">
                        </td>
                        <td>
                            <h5 class="form-lable">Gaurantor:</h5>
                            <input type="text" pInputText placeholder="Name of the Gaurantor">
                        </td>
                    </tr>
                    <tr><td> <h4 class="title-f" style="margin-top: 15px;">Contact Details</h4> </td></tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Gender/Maritial Status:</h5>
                            <input type="text" pInputText placeholder="" value="M/Single">
                        </td>
                        <td>
                            <h5 class="form-lable">DOB:</h5>
                            <input type="text" pInputText placeholder="" value="07-09-1992">
                        </td>
                        <td>
                            <h5 class="form-lable">Nationality:</h5>
                            <input type="text" pInputText placeholder="" value="Indian">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Occupation Desg:</h5>
                            <input type="text" pInputText placeholder="" value="Software">
                        </td>
                        <td>
                            <h5 class="form-lable">Delq.string:</h5>
                            <input type="text" pInputText placeholder="" value="1/1/NA/NA/NA/NA/NA">
                        </td>
                        <td>
                            <h5 class="form-lable">Cycle String:</h5>
                            <input type="text" pInputText placeholder="" value="1/2-/-/-/-/-/-/[3/7]">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Sticky Notes:</h5>
                            <input type="text" pInputText placeholder="" value="Account Sticky Notes be shown">
                        </td>
                        <td>
                            <h5 class="form-lable">Customer Sticky Notes:</h5>
                            <input type="text" pInputText placeholder="" value="Customer Stiky Notes be shown">
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                    <tr>
                        <td> <h4 class="title-f" style="margin-top: 15px;">Payment Details</h4> </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Last Paid Date:</h5>
                            <input type="text" pInputText placeholder="" value="05-11-2013">
                        </td>
                        <td>
                            <h5 class="form-lable">Payment Mode:</h5>
                            <input type="text" pInputText placeholder="" value="Cash">
                        </td>
                        <td>
                            <h5 class="form-lable">Collected By:</h5>
                            <input type="text" pInputText placeholder="CHARILE">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Amount</h5>
                            <input type="text" pInputText placeholder="" value="12000">
                        </td>
                        <td>
                            
                        </td>
                        <td>
                            
                        </td>
                    </tr>
                    <tr>
                        <td><h4 class="title-f" style="margin-top: 15px;">Financial Details</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">OS Amount:</h5>
                            <input type="text" pInputText placeholder="" value="340000">
                        </td>
                        <td>
                            <h5 class="form-lable">OD Amount:</h5>
                            <input type="text" pInputText placeholder="" value="42000">
                        </td>
                        <td>
                            <h5 class="form-lable">OD Days:</h5>
                            <input type="text" pInputText placeholder="" value="61">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Times Delq.#:</h5>
                            <input type="text" pInputText placeholder="" value="2">
                        </td>
                        <td>
                            <h5 class="form-lable">Peak OD Days:</h5>
                            <input type="text" pInputText placeholder="" value="71">
                        </td>
                        <td>
                            <h5 class="form-lable">Delq. Start Date:</h5>
                            <input type="text" pInputText placeholder="" value="05.7.2014">
                        </td>
                    </tr>
                    <tr>
                        <td>
            
                            <h5 class="form-lable">Bucket:</h5>
                            <input type="text" pInputText placeholder="" value="3">

                        </td>
                        <td>
            
                            <h5 class="form-lable">Cycle Days:</h5>
                            <input type="text" pInputText placeholder="" value="12">

                        </td>
                        <td>
            
                            <h5 class="form-lable">Action/Result:</h5>
                            <input type="text" pInputText placeholder="" value="OC/PTP">

                        </td>
                    </tr>
                    <tr>
                        <td><h4 class="title-f" style="margin-top: 15px;">Assets Details</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Model:</h5>
                            <input type="text" pInputText placeholder="" value="MU-X">
                        </td>
                        <td>
                            <h5 class="form-lable">Brand:</h5>
                            <input type="text" pInputText placeholder="" value="ISUZU">
                        </td>
                        <td>
                            <h5 class="form-lable">Color:</h5>
                            <input type="text" pInputText placeholder="" value="Black">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Engine No:</h5>
                            <input type="text" pInputText placeholder="" value="12365478529">
                        </td>
                        <td>
                            <h5 class="form-lable">Chassis No:</h5>
                            <input type="text" pInputText placeholder="" value="87956421225">
                        </td>
                        <td>
                            <h5 class="form-lable">VIN Number:</h5>
                            <input type="text" pInputText placeholder="" value="61255858256">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Lisence No:</h5>
                            <input type="text" pInputText placeholder="" value="LIC187212">
                        </td>
                        <td>
                            <h5 class="form-lable">Changwat:</h5>
                            <input type="text" pInputText placeholder="" value="BANGKOK">
                        </td>
                        <td>
                            <h5 class="form-lable">Reg.Year:</h5>
                            <input type="text" pInputText placeholder="" value="2010">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Dealer:</h5>
                            <input type="text" pInputText placeholder="" value="Dealer Code">
                        </td>
                        <td>
                            <h5 class="form-lable">Showroom:</h5>
                            <input type="text" pInputText placeholder="" value="Showroom Name">
                        </td>
                        <td>
                            <h5 class="form-lable">MO Name:</h5>
                            <input type="text" pInputText placeholder="" value="Marketing Officer Name">
                        </td>
                    </tr>
                    <tr>
                        <td> <h4 class="title-f" style="margin-top: 15px;">Follow Up Details</h4> </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Date/User:</h5>
                            <input type="text" pInputText placeholder="" value="01-05-2014">
                        </td>
                        <td>
                            <h5 class="form-lable">Action/Result:</h5>
                            <input type="text" pInputText placeholder="" value="OC/PTP">
                        </td>
                        <td>

                        </td>
                    </tr>
                    <tr>
                        <td><h4 class="title-f" style="margin-top: 15px;">Promise Details</h4></td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Taken On:</h5>
                            <input type="text" pInputText placeholder="" value="01.05.2014">
                        </td>
                        <td>
                            <h5 class="form-lable">Taken By:</h5>
                            <input type="text" pInputText placeholder="" value="CHERILE">
                        </td>
                        <td>
                            <h5 class="form-lable">Promise Date:</h5>
                            <input type="text" pInputText placeholder="" value="04.05.2014">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Amount Status:</h5>
                            <input type="text" pInputText placeholder="" value="15000 Live">
                        </td>
                        <td>
                            <h5 class="form-lable">Payment Date:</h5>
                            <input type="text" pInputText placeholder="" value="03.05.2014">
                        </td>
                        <td>
                            <h5 class="form-lable">Payment Amounts:</h5>
                            <input type="text" pInputText placeholder="" value="">
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h4 class="title-f" style="margin-top: 15px;">Payment Details</h4>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <h5 class="form-lable">Transaction Date:</h5>
                            <input type="text" pInputText placeholder="">
                        </td>
                        <td>
                            <h5 class="form-lable">Value Date:</h5>
                            <input type="text" pInputText placeholder="">
                        </td>
                        <td>
                            <h5 class="form-lable">Amount:</h5>
                            <input type="text" pInputText placeholder="" value="">
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>


<button class="btn btn-sm btn-dark" ngxPrint printSectionId="print-section">Print</button>
